export default "__VITE_ASSET__2f1e910b__"